import { fromJS } from 'immutable'
import {
  DIVISION_GET_REQUEST,
  DIVISION_GET_SUCCESS,
  DIVISION_GET_FAILURE,
  DIVISION_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case DIVISION_GET_REQUEST:
      return state
        .set('isFetching', true)
    case DIVISION_GET_SUCCESS:
      return state
        .set('division', fromJS(action.payload.division))
        .set('isFetching', false)
    case DIVISION_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case DIVISION_GET_RESET:
      return state
        .delete('division')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/division/division-get-reducer.js